import React, { useState, useEffect } from "react";
import { ReactComponent as GroupIcon } from "assets/icons/group.svg";
const PackageDetailsCarousel = ({ images, minTravellers }) => {
  const _image = images?.length > 0 ? images[0] : null;

  const [activeImg, setActiveImg] = useState(_image);

  useEffect(() => {
    setActiveImg(images[0]);
  }, [images]);

  return (
    <div className="package-details">
      <div>
        {images && images?.length > 0 && (
          <div>
            <div className=" bg-gray-300 w-full h-[500px] rounded-lg overflow-hidden relative">
              <img
                className="h-full w-full object-cover"
                src={activeImg}
                alt={activeImg}
              />
              {minTravellers > 1 && (
                <div className="absolute bottom-8 left-2">
                  <GroupIcon />
                  <p className="absolute z-10 top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 font-bold text-sm text-center">
                    <p className="text-center text-[#093549]/90">Group Deal</p>
                  </p>
                </div>
              )}
            </div>

            <div className="mt-4 flex items-center gap-x-3">
              {images?.map((image, index) => (
                <div
                  onClick={() => setActiveImg(image)}
                  key={index}
                  className={`${
                    activeImg === image && "border border-black-100/50 p-1"
                  } w-20 h-16 rounded-lg relative overflow-hidden`}
                >
                  <img
                    className="h-full w-full object-cover"
                    src={image}
                    alt={`image-${index}`}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PackageDetailsCarousel;
